import React from 'react';
import { Link } from 'react-router-dom';
import Seo from '../components/Seo';

function NotFound() {
  return (
    <div className="not-found-page">
      <Seo title="404 - Page Not Found" noindex />
      <section className="page-banner">
        <h1>Page not found</h1>
        <p>That address is not on this site. If you were looking for a test, a pathologist, or the lab, these links will get you there.</p>
      </section>
      <div className="not-found-actions">
        <Link to="/" className="cta-button">Home</Link>
        <Link to="/contact" className="cta-button secondary">Contact the lab</Link>
      </div>
    </div>
  );
}

export default NotFound;
